module.exports = ".dropdown {\n  height: 48px;\n  width: 100%;\n  line-height: 48px;\n  padding: 5px;\n  background-color: var(--header); }\n\n.select {\n  width: auto;\n  float: left; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dropdown/dropdown.component.scss
// module id = ./src/app/modules/dropdown/dropdown.component.scss
// module chunks = main